<template>
    <b-card no-body>

        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <vehicle-type-create-or-update v-model="vehicleType"></vehicle-type-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"
                    search
                    pagination="server"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { VehicleTypeApi } from '@/api/vehicle-type'
import VehicleTypeCreateOrUpdate from './components/VehicleTypeCreateOrUpdate.vue'
export default {
    components:{
        BCard,
        VehicleTypeCreateOrUpdate
    },
    data(){
        return{
            editing:false,
            loading:false,
            fields:[
                {name:'Araç Tipi Kodu',key:'Code',sortable:true, thClass:'w-15'},
                {name:'Araç Tipi Adı',key:'Name',sortable:true, thClass:'w-85'},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            vehicleType:{
                Id:null,
                Name: null,
                Code:null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.vehicleType.Id = null
            this.vehicleType.Name = null
            this.vehicleType.Code = null
            
        },
        provider(data){
            return VehicleTypeApi.Table(data)
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.vehicleType.Id = item.Id
            this.vehicleType.Name = item.Name
            this.vehicleType.Code = item.Code
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            VehicleTypeApi.CreateOrUpdate(this.editing,this.vehicleType).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('create-or-update')
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} adlı araç tipini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    VehicleTypeApi.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>